import moment from 'moment'

export function firebaseToMomentDate(fb: any): moment.Moment | null {
  if (!fb) {
    return null
  }
  // usually it is firebase.firestore.Timestamp
  if (typeof fb.toDate === 'function') {
    return moment(fb.toDate())
  } else {
    return moment(fb)
  }
}

export function firebaseToDate(fb: any): Date | null {
  if (!fb) {
    return null
  }

  if (typeof fb.toDate === 'function') {
    return fb.toDate()
  } else {
    console.warn('Could not parse object to date', fb)
    return null
  }
}
